<template lang='pug'>
  v-container.px-3.purchases-container(fluid)
    //- Details
    v-dialog( :fullscreen="isMobile" width="500" persistent :value='detailsDialog' transition="dialog-bottom-transition")
      Details(v-if='detailsDialog' @showSupportImage='showSupportImage' @showProduct='productDialog = true' :request='currentRequest' @close="detailsDialog=false;" admin="purchase")
    //- Create purchase
    v-dialog(persistent :value='purchaseDialog'  max-width='800px' :fullscreen="isMobile" transition="dialog-bottom-transition" )
      PurchaseForm(v-if='purchaseDialog' @close="purchaseDialog = false; fetch()")
    //- Preview dialog
    v-dialog(:fullscreen='isMobile' persistent :key='currentItem.name' :value='productDialog'  max-width='800px'   transition="dialog-bottom-transition")
      Preview(v-if='productDialog' :model='currentItem' @close='productDialog=false')
    //- Content
    v-row.px-3.justify-space-between.align-center.my-0
      v-col(cols="6" xs="6" sm="6" md="6")
        v-btn.main-btn-gradient(small color='#3cbbc2' style="height: 48px;" @click="onexport()")
          v-icon mdi-arrow-collapse-down
          | Exportar
      v-col.d-flex.justify-end(cols="6" xs="6" sm="6" md="6")
        //- Update btn
        v-btn.main-btn-gradient(small style="height: 48px;" @click="fetch()")
          v-icon mdi-refresh
        //- Date filter
        v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
          template(v-slot:activator='{ on }')
            v-btn.main-btn-gradient(small color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
              v-icon mdi-calendar
              | {{$t('sales.dates')}}
          v-card(style="border:3px solid #3cbbc2;").pa-2
            date-filter(@closeMenu="fetch('purchases', false, $event)" :currentType= 'currentType',)
    v-row.px-5.my-0
      MovementTransactions(
        title="Movimientos compras"
        :movements="transactionTotals.qty.toString()"
        :total="transactionTotals.total.toFixed(2)"
        utility=""
      )
    v-row.px-5.my-0.pb-5
      v-card.rounded-lg.pa-3( width="100%")
        v-row
          //- Shops
          v-col.pb-0(cols="6" xs="6" sm="4" md="4")
            v-select.rounded-xl(
              :label="$t('purchases.filter_by_store')",
              elevation=0
              outlined
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row.my-1
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
          //- Provider
          v-col.pb-0(cols="6" xs="6" sm="4" md="4")
            v-select.rounded-xl(
              label="Proveedores"
              elevation=0
               outlined
              :items='providers'
              v-model="provider"
              item-text='name'
              dense
              solo
              clearable
              @input='selectProvider'
              @click:clear='clearProvider'
            )
          //- Create purchase
          v-col.pb-0.d-flex.create-btn(cols="12" xs="6" sm="4" md="4")
            v-btn.main-btn-gradient(small @click="purchaseDialog=true" style="height: 48px;").mt-0
              v-icon mdi-plus
              | Agregar {{$t('purchases.purchases_bill')}}
        v-row
          v-col(cols='12' md='12')
            .card-transactions
              v-progress-linear(v-if="loading" indeterminate color="#008e95")
              //- Desktop
              .show-table-desktop
                v-data-table.elevation-0(:headers="headers" :items="filteredTransactions.slice(10*(page-1), 10*(page)) || []" :expanded.sync="expanded" item-key="name"  show-expand :search="search" hide-default-header hide-default-footer)
                  //- Headers
                  template(v-slot:header="{ props }")
                    th(v-for="head in props.headers" stylw="height: 30px;")
                      | {{ head.text }}
                      v-tooltip(v-if="head.value== 'items'" bottom='')
                        template(v-slot:activator='{ attrs, on }')
                          v-icon(v-on='on') mdi-help-circle-outline
                        span
                          p Aquí se muestra las cantidades de cada producto
                          p y el movimiento en inventario que genera cada factura (Vienen →  Quedan)
                  //- Content
                  template( v-slot:item="props" )
                    tr(@click="props.item.items ? openDetail(props.item) : '' " :style="props.item.items ? 'cursor: pointer;' : ''")
                      td.text-xs-left
                        .datatable-cell-wrapper {{ props.item.reference_number }}
                      td.text-xs-left(hidden)
                        | {{props.item.items}}
                      td
                        span(v-html="productsInOrder(props.item.items)")
                      td.text-xs-left
                        .datatable-cell-wrapper  {{ props.item.time | moment }}
                      td.text-xs-left.red--text(v-if="props.item.isCanceled || !props.item.items") Anulada
                      td.text-xs-left(v-else :style='getstatus(props.item.items) === "completed" ? "color: green":"color: #fb8c00"')
                        .datatable-cell-wrapper  {{getstatus(props.item.items) | translateStatus}}
                      td.text-xs-left()
                        .datatable-cell-wrapper {{props.item.provider ? props.item.provider : ''}}
                      td.text-xs-left()
                        .datatable-cell-wrapper {{ props.item.location_to ? props.item.location_to.name : ''}}
                      td.text-xs-left(v-if="props.item.type !=='transfers'")
                        .datatable-cell-wrapper {{ props.item.total | numberFormat}}
                v-pagination.my-4(v-model="page" :length="pageNumber" :total-visible="11")
              //- Mobile
              v-list.show-table-mobile(two-line="" v-if="filteredTransactions.length > 0")
                v-list-item-group(style="width: 100%;")
                  template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                    v-list-item(:key="item.reference_number").notification
                        template(v-slot:default="{ active, toggle }")
                            v-list-item-content(@click="item.items ? openDetail(item) : '' ")
                                p.font-weight-bold # {{item.reference_number}}
                                p.mt-2 {{item.provider ? item.provider : ''}}
                                p.mt-2 {{ item.location_to ? item.location_to.name : ''}}
                                p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                                p(v-if="item.isCanceled || !item.items").red--text.text-caption Anulada
                                p.mt-2(v-else) {{getstatus(item.items) | translateStatus}}
                                p(v-if="item.type !=='transfers'").mt-2.font-weight-bold.notification__price {{ item.total | numberFormat}}
                        v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                  v-pagination.my-4(v-model="page" :length="pageNumber")
              .show-table-mobile(v-else)
                NoResults(title="No tienes compras", description="Puedes ver tus compras en otro rango de fechas")
    //- Old content
    //- v-layout(wrap='')
      v-flex(md12='', v-show="getCurrentType !== null || field!==null || sold!==null"  :style="isMobile ? 'padding-left: 20px !important; padding-right: 20px !important;': ''")
        // v-btn(color="#009da5" fab small dark="" v-if="isMobile" @click="$router.go(-1)").mt-2.ml-5
          v-icon(size="25") mdi-arrow-left
        v-col(v-if="isMobile" cols="12" style="position: relative;")
          v-icon(style="z-index: 10; position: absolute; left: 0; top: 0;" size="65" color="#30b5bb" @click="$router.go(-1)") mdi-chevron-left
          h2.purchases__title.purchases__underline Compras
        v-card(v-if="!isMobile")
          v-card-title.mb-4 {{$t('purchases.title')}}
          .text-center(style="display:flex; align-items:flex-start;margin-left: 25px !important").mt-2
            //- v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
              template(v-slot:activator='{ on }')
                v-btn(color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
                  v-icon mdi-calendar
                  | {{$t('purchases.dates')}}

              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="fetch('purchases', false, $event)" :currentType= 'currentType',)
            .text-center(style="display:flex; align-items:center;")
              v-select.elevation-0(
              :label="$t('purchases.filter_by_store')",
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
              //- Select provider
              v-select.elevation-0(
                label="Proveedores"
                :items='providers'
                v-model="provider"
                item-text='name'
                dense
                solo
                clearable
                @input='selectProvider'
                @click:clear='clearProvider'
              )
            //-
              v-btn(v-if="!isMobile" medium color='#3cbbc2' @click="purchaseDialog=true").mx-8
                v-icon(left='' small) mdi-plus
                | {{$t('purchases.purchases_bill')}}
            v-card(style='margin: 2px;' flat link @click="purchaseDialog=true" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Agregar {{$t('purchases.purchases_bill')}}
                    img.mr-4.ml-2(style='height:36px' :src="addPurchaseIcon")
            //- v-card(style='margin: 2px;' flat link @click="fetch()" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.mt-2.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 200px;") Actualizar
                    // img.mr-4.ml-2(style='height:36px' :src="updateIcon")
                    v-icon mdi-refresh
            //- v-card(style='margin: 2px;' flat link @click="onexport()" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.mt-2.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 200px;") Exportar
                    // img.mr-4.ml-2(style='height:36px' :src="updateIcon")
                    v-icon mdi-file-excel
          //-
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="purchaseDialog=true" height="20" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Agregar {{$t('purchases.purchases_bill')}}
                    img.mr-4.ml-2(style='height:36px' :src="addPurchaseIcon")
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="fetch()" height="20" outlined).category-card.py-6.mx-4.mb-8
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.mt-2.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Actualizar
                    // img.mr-4.ml-2(style='height:36px' :src="updateIcon")
                    v-icon mdi-refresh
          // Cards
          //- v-layout.bill-action__button-row().my-2
          //- v-flex(style='display:flex; flex-direction: row; flex-wrap: wrap; justify-content:flex-start; align-items:center;')
            v-flex(sm6='', xs12='', md6='', lg4='')
              base-material-stats-card( v-if ='!!transactions'  color='warning', icon='mdi-swap-vertical', small-value='#' :title="$t('purchases.movements')", :value='transactionTotals.qty.toString()')
            v-flex(sm6='', xs12='', md6='', lg4='')
              base-material-stats-card( color='cyan', icon='mdi-currency-usd', small-value='$' :title="$t('purchases.total')", :value=' transactionTotals.total.toFixed(2)')
          v-card
            v-progress-linear(v-if="loading" indeterminate color="cyan")
            //- v-card-title
              v-text-field(v-model='search',@input='setSearchCriteria' append-outer-icon='mdi-search', :label="$t('purchases.search')" placeholder="Buscar por referencia, establecimiento o proveedor" single-line='', hide-details='')
            // Desktop
            v-data-table.elevation-0(:headers="headers" :items="filteredTransactions.slice(10*(page-1), 10*(page)) || []" :expanded.sync="expanded" item-key="name"  show-expand :search="search" hide-default-header hide-default-footer)
              //- Headers
              template(v-slot:header="{ props }")
                th(v-for="head in props.headers" stylw="height: 30px;")
                  | {{ head.text }}
                  v-tooltip(v-if="head.value== 'items'" bottom='')
                    template(v-slot:activator='{ attrs, on }')
                      v-icon(v-on='on') mdi-help-circle-outline
                    span
                      p Aquí se muestra las cantidades de cada producto
                      p y el movimiento en inventario que genera cada factura (Vienen →  Quedan)
              //- Content
              template( v-slot:item="props" )
                tr(@click="props.item.items ? openDetail(props.item) : '' " :style="props.item.items ? 'cursor: pointer;' : ''")
                  td.text-xs-left
                    .datatable-cell-wrapper {{ props.item.reference_number }}
                  td.text-xs-left(hidden)
                    | {{props.item.items}}
                  td
                    span(v-html="productsInOrder(props.item.items)")
                  td.text-xs-left
                    .datatable-cell-wrapper  {{ props.item.time | moment }}
                  td.text-xs-left.red--text(v-if="props.item.isCanceled || !props.item.items") Anulada
                  td.text-xs-left(v-else :style='getstatus(props.item.items) === "completed" ? "color: green":"color: #fb8c00"')
                    .datatable-cell-wrapper  {{getstatus(props.item.items) | translateStatus}}
                  td.text-xs-left()
                    .datatable-cell-wrapper {{props.item.provider ? props.item.provider : ''}}
                  td.text-xs-left()
                    .datatable-cell-wrapper {{ props.item.location_to ? props.item.location_to.name : ''}}
                  td.text-xs-left(v-if="props.item.type !=='transfers'")
                    .datatable-cell-wrapper {{ props.item.total | numberFormat}}
            v-pagination.my-4(v-model="page" :length="pageNumber" :total-visible="11")
        v-container(v-else)
          .text-center(style="display:flex; align-items:flex-start;margin-left: 15px !important").mt-2
            .text-center(style="display:flex; align-items:center;")
              v-select.elevation-0.select(
                label="Proveedores"
                :items='providers'
                v-model="provider"
                item-text='name'
                dense
                solo
                clearable
                @input='selectProvider'
                @click:clear='clearProvider'
              )
              v-select.elevation-0.mr-4(
              :label="$t('purchases.filter_by_store')",
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
            v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
              template(v-slot:activator='{ on }')
                v-btn(color='#3cbbc2' small dark='', v-on='on' style="height: 38px;").mt-0
                  v-icon mdi-calendar
              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="fetch('purchases', false, $event)" :currentType= 'currentType',)
            //-
              v-btn(v-if="!isMobile" medium color='#3cbbc2' @click="purchaseDialog=true").mx-8
                v-icon(left='' small) mdi-plus
                | {{$t('purchases.purchases_bill')}}
          v-row.mt-2.mb-8.pr-4
            v-col(cols="6" @click="purchaseDialog=true").pr-1
              v-btn.ma-2.white--text.btn-transaction(block)
                | {{$t('purchases.purchases_bill')}}
                v-icon(right="" dark="")
                  | mdi-plus
            v-col(cols="6" @click="fetch()").pl-0
              v-btn.ma-2.white--text.btn-transaction(block)
                | Actualizar
                v-icon(right="" dark="")
                  | mdi-refresh
          //-
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="purchaseDialog=true" height="20" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Agregar {{$t('purchases.purchases_bill')}}
                    img.mr-4.ml-2(style='height:36px' :src="addPurchaseIcon")
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="fetch()" height="20" outlined).category-card.py-6.mx-4.mb-8
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.mt-2.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Actualizar
                    // img.mr-4.ml-2(style='height:36px' :src="updateIcon")
                    v-icon mdi-refresh
          // Cards
          v-row.px-2
            v-col(cols="12")
              mobileCard(color='cyan', icon='mdi-currency-usd', valueIcon='$' :title="$t('purchases.total')", :value=' transactionTotals.total.toFixed(2)')
            v-col(cols="12")
              mobileCard(v-if ='!!transactions'  color='warning', icon='mdi-swap-vertical', valueIcon='#' :title="$t('purchases.movements')", :value='transactionTotals.qty.toString()')
          v-card
            v-progress-linear(v-if="loading" indeterminate color="cyan")
            //- v-card-title
              v-text-field(v-model='search' @input='setSearchCriteria' outlined prepend-inner-icon="mdi-magnify" placeholder="Buscar por referencia o establecimiento")
            // Mobile
            v-flex(md12='' style="max-width: 700px").mx-auto.mt-3
              v-list(two-line="" v-if="filteredTransactions.length > 0")
                v-list-item-group
                  template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                    v-list-item(:key="item.reference_number").notification
                        template(v-slot:default="{ active, toggle }")
                            v-list-item-content(@click="item.items ? openDetail(item) : '' ")
                                p.font-weight-bold # {{item.reference_number}}
                                p.mt-2 {{item.provider ? item.provider : ''}}
                                p.mt-2 {{ item.location_to ? item.location_to.name : ''}}
                                p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                                p(v-if="item.isCanceled || !item.items").red--text.text-caption Anulada
                                p.mt-2(v-else) {{getstatus(item.items) | translateStatus}}
                                p(v-if="item.type !=='transfers'").mt-2.font-weight-bold.notification__price {{ item.total | numberFormat}}
                        v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                  v-pagination.my-4(v-model="page" :length="pageNumber")
              template(v-else)
                NoResults(title="No tienes compras", description="Puedes ver tus compras en otro rango de fechas")
</template>

<script>
  import XLSX from 'xlsx'
  import moment from 'moment'
  import DateFilter from '@/components/custom/filters/DateFilter'
  import PurchaseForm from '@/components/custom/forms/PurchaseForm'
  import Preview from '@/components/custom/preview/ProductPreview'
  import BillPreview from '@/components/custom/preview/transactions/PurchasesBillPreview'
  import loaders from '@/plugins/mixins/loaders'
  import addPurchaseIcon from '@/assets/icons/home/compra.png'
  import updateIcon from '@/assets/icons/home/update.png'
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })
  export default {
    components: {
      BillPreview: BillPreview,
      Preview: Preview,
      PurchaseForm: PurchaseForm,
      DateFilter: DateFilter,
      NoResults: () => import('@/components/custom/NoResults'),
      Details: () => import('@/views/marketplace/component/profile/RequestDetails'),
      mobileCard: () => import('@/views/custom/transactions/MobileCard.vue'),
      MovementTransactions: () => import('@/components/custom/transactions/movement_transactions'),
    },
    filters: {
      moment: function (date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')
      },
      momentHours: function (date) {
        return moment(date).format('hh:mm a')
      },
      moneyFormat: function (value) {
        return formatter.format(value)
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      translate: function (name) {
        switch (name) {
          case 'sales':
            return 'Venta'

          case 'purchases':
            return 'Compra'

          case 'transfers':
            return 'Traslado'

          case 'returns':
            return 'Devolucion'

          case 'store':
            return 'Tienda'

          case 'warehouse':
            return 'Bodega'
        }
      },
      translateStatus (value) {
        if (value) {
          switch (value) {
            case 'pending':
              return 'Pendiente'
            case 'completed':
              return 'Completo'
          }
        } else {
          return 'N/A'
        }
      },
    },
    mixins: [loaders],
    data () {
      return {
        loading: false,
        updateIcon,
        addPurchaseIcon,
        dateFrom: '',
        dateTo: '',
        currentRequest: '',
        detailsDialog: false,
        page: 1,
        fav: true,
        menu: false,
        message: false,
        hints: true,
        currentLocation: null,
        select: {},
        confirmationDialog: false,
        currentItemId: null,
        currentTransaction: null,
        selectedItem: {},
        purchaseDialog: false,
        transferDialog: false,
        expensesDialog: false,
        expanded: [],
        singleExpand: false,
        expensesExpanded: [],
        search: '',
        currentType: '',
        expenses: 0,
        // EXPENSES VARIABLES
        updateItemDialog: false,
        createItemDialog: false,
        productDialog: false,
        // --FINISH EXPENSES VARIABLES
        dialog: false,
        headers: [
          {
            sortable: false,
            text: '# de referencia',
            value: 'type',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.products'),
            value: 'items',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.time'),
            value: 'time',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.status'),
            value: 'status',
            align: 'left',
          },
          {
            sortable: false,
            text: this.$t('purchases.table_headers.origin'),
            value: 'provider',
            align: 'left',

          },
          {
            sortable: false,
            text: this.$t('purchases.table_headers.destination'),
            value: 'location_to.name',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.total'),
            value: 'total',
            align: 'left',

          },
          {
            text: '',
            value: 'data-table-expand',
          },
        ],

        headersTwo: [

          {
            sortable: true,
            text: 'Razón del gasto',
            value: 'name',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Monto',
            value: 'ammount',
            align: 'left',

          },
          {
            sortable: true,
            text: 'Tipo de gasto',
            value: 'type',
            align: 'left',
          },

          {
            sortable: false,
            text: 'Acciones',
            value: 'actions',
            align: 'left',

          },
        ],
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false,
        },
        provider: null,
        selectedDate: null,
        transactionTotals: {
          qty: 0,
          revenue: 0,
          total: 0,
        },
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      /* loading () {
        return this.$store.getters['loading/getLoading']
      }, */

      // --FINISH EXPENSES
      getCurrentType () {
        return this.$store.getters['transactions/getCurrentType']
      },
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
      sold () {
        return this.$store.getters['transactions/getTransactionsTotal']
      },
      revenue () {
        return this.$store.getters['transactions/getRevenueTotal']
      },
      currentItem () {
        return this.$store.getters['products/getCurrentItem']
      },
      currentShop () {
        return this.$store.getters['shops/getCurrentItem']
      },
      products () {
        return [
          {
            name: 'Todos',
            value: '',
          },
          // ...this.$store.getters.getInventory,
        ]
      },
      purchases () {
        const vm = this
        return vm.$store.getters['transactions/getPurchases']
        // return this.$store.state.transactions.purchases
      },
      transactions () {
        const vm = this
        if (!!vm.currentLocation && !!vm.purchases) {
          return vm.purchases.filter((el) => {
            if (el.location_to.id === vm.currentLocation.id) {
              // console.log(el.location_to.id, vm.currentLocation.id)
              return true
            }
          })
        } else if (vm.purchases) {
          return vm.purchases
        } else {
          return vm.purchases
        }
      },
      /* transactionTotals () {
        const vm = this
        let total = 0
        let revenue = 0
        // console.log(revenue)
        if (vm.transactions) {
          const list = vm.transactions.filter(el => !el.isCanceled) || {}
          list.forEach(element => {
            // if( Vue.moment().isSame(element.time, state.currentDateFilter))
            total += +element.total
            if (element.items) {
              element.items.forEach(item => {
                if (item.purchase) {
                  revenue += (+item.price - +item.purchase) * +item.amount
                }
              })
            }
          })
          return {
            total: total,
            revenue: revenue,
          }
        }
        return {
          total: 0,
          revenue: 0,
        }
      }, */
      pageNumber () {
        if (!this.transactions || this.transactions.length === 0) return 0
        if (this.isMobile) {
          return Math.ceil(this.filteredTransactions.length / 10)
        } else {
          return Math.ceil(this.transactions.length / 10)
        }
      },
      filteredTransactions () {
        // console.log(this.transactions, 'estoy filtrando las transacciones')
        if (!this.transactions || this.transactions.length === 0) return []
        return this.transactions.filter((transaction) => {
          return transaction.provider.toLowerCase().match(this.search.toLowerCase()) || transaction.location_to.name.toLowerCase().match(this.search.toLowerCase()) || transaction.reference_number.toString().includes(this.search)
        })
      },
      providers () {
        return this.$store.getters['providers/getItems']
      },
    },
    watch: {
      transactions (val, oldval) {
        // console.log(val, oldval)
        /* const vm = this
        vm.loading = false */
      },
      $route (to, from) {
        // react to route changes...
        if (this.$route.params.type) {
          this.currentType = this.$route.params.type
          // console.log(this.$route.params.type)
        } else this.currentType = 'sales'
      },
      page (val, oldVal) {
        const vm = this
        if (val >= vm.pageNumber - 1) {
          vm.getNextPages()
        }
      },
    },
    created () {
      this.currentType = this.$route.params.type
      this.fetch()
      if (this.providers.length === 0) {
        this.loadProviders()
      }
    },
    beforeDestroy () {
      this.$store.dispatch('transactions/clearTransactions').then(function (res) {
        // console.log('transactions cleared')
      })
      this.clearShopSelection()
    },
    mounted () {
      // this.$store.dispatch('loading/setLoading',false);
      // const vm = this
      // setTimeout(() => { vm.$store.dispatch('loading/setLoading', false); vm.loading = false }, 2000)
    },
    methods: {
      productsInOrder (products) {
        const vm = this
        let productsString = ''
        const style = 'display: flex; flex-direction: row; justify-content: space-between; width: 350px;'
        if (products) {
          products.forEach((product, index) => {
            const qty = product.qty || product.qty === 0 ? product.qty : null
            if (index !== products.length - 1) {
              productsString += qty || qty === 0 ? `<div style="${style}"><p>${product.amount} - ${vm.overflowName(product.name)}</p><p>( ${qty} &#8594 ${+product.qty + +product.amount} )</p></div>` : `<div style="${style}"><p>${product.amount} ${vm.overflowName(product.name)}</p></div>`
            } else {
              productsString += qty || qty === 0 ? `<div style="${style}"><p>${product.amount} - ${vm.overflowName(product.name)}</p><p>( ${qty} &#8594 ${+product.qty + +product.amount} )</p></div>` : `<div style="${style}"><p>${product.amount} ${vm.overflowName(product.name)}</p></div>`
            }
          })
        } else {
          return 'Esta compra no tiene productos'
        }
        if (productsString.length > 500) {
          return productsString.substring(0, 500) + '...'
        } else {
          return productsString
        }
      },
      overflowName (value) {
        if (value.length > 40) return value.substring(0, 40) + '...'
        return value
      },
      productsInOrderExcel (products) {
        // span(v-for='product in props.item.items') {{product.name}},
        let productsString = ''
        if (products) {
          products.forEach((product, index) => {
            if (index !== products.length - 1) {
              productsString += '(' + product.amount + ') ' + product.name + ', '
            } else {
              productsString += '(' + product.amount + ') ' + product.name
            }
          })
          return productsString
        } else {
          return 'Esta compra no tiene productos'
        }
      },
      openDetail (item) {
        const vm = this
        vm.currentRequest = item
        vm.detailsDialog = true
      },
      // Expenses
      optimize () {
        this.$store.dispatch('transactions/optimizeTransactions').then(function (data) {
          // res
          // console.log('termino!')
        })
      },

      openDeleteDialog (id) {
        const vm = this
        vm.currentItemId = id
        vm.confirmationDialog = true
        vm.localLoad = true
      },
      deleteExpensesItem (id) {
        const vm = this
        this.$store.dispatch('expenses/deleteItem', id).then(function () {
          vm.confirmationDialog = false
          vm.dialog = false
          vm.fetch()
        },
        ).catch(function (err) {
          console.log(err)
          vm.confirmationDialog = false
          vm.dialog = false
        })
      },

      // -- FINISH EXPENSES

      showSupportImage (url) {
        this.$swal({
          title: 'Soporte',
          text: 'Modal with a custom image.',
          // imageUrl: url,
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: 'Custom image',
          html: `
              <a target="_blank" href="${url}" download>
                <img style='max-height: 500px;' src="${url}" alt="comprobante">
              </a>
                    `,
          showConfirmButton: true,
        })
      },
      loadLog (type, dateFrom, dateTo) {
        const vm = this
        vm.page = 1
        vm.transactionTotals = {
          qty: 0,
          revenue: 0,
          total: 0,
        }
        vm.$store.dispatch('transactions/loadLogTotals', { type: type, from: dateFrom, to: dateTo, provider: vm.provider }).then(function (res) {
          vm.transactionTotals = { ...res }
          vm.loading = false
        })
        vm.$store.dispatch('transactions/loadLog', [type, dateFrom, dateTo, false, vm.provider]).then(function () {})
      },
      fetch (type = 'purchases', initial = true, dates = null) {
        const vm = this
        vm.menu = false
        vm.loading = true
        vm.selectedDate = dates
        if (initial) {
          vm.dateFrom = vm.$moment().format('YYYY-MM-DD')
          vm.dateTo = vm.$moment(vm.dateFrom).add(1, 'days').format('YYYY-MM-DD')
          vm.loadLog(type, vm.dateFrom, vm.dateTo)
        } else {
          vm.dateFrom = moment(dates.from).format('YYYY-MM-DD')
          vm.dateTo = moment(dates.to).subtract(1, 'days').format('YYYY-MM-DD')
          vm.loadLog(type, vm.dateFrom, vm.dateTo)
        }
      },

      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null).then(function () {
        })
      },
      selectShop (item) {
        const vm = this
        // console.log(item)
        vm.$store.dispatch('shops/setCurrentItem', item).then(function () {
          // console.log(vm.$store.getters['shops/getCurrentItem'])
        })
      },

      setSearchCriteria (val) {
        const vm = this

        vm.$store.dispatch('transactions/setFilterCriteria', val).then(function () {
          //
        })
      },
      setFilterCriteria () {
        const vm = this

        this.$store.dispatch('transactions/setFilterCriteria', vm.select).then(function () {
          //
        })
      },
      clearFilter () {
        const vm = this

        vm.$store.dispatch('clearFilter').then(function () {
          //
        })
      },

      close (dialog) {
        const vm = this
        switch (dialog) {
          case 'productDialog':
            vm.productDialog = false
            break
          case 'expensesDialog':
            vm.expensesDialog = false
            break
        }
      },

      getstatus (items) {
        // console.log(items)
        const found = items.find(element => element.status === 'pending')
        // console.log(found)
        if (found) {
          return 'pending'
        } else {
          return 'completed'
        }
      },

      onexport () {
        const vm = this
        const products = []
        vm.transactions.forEach(element => {
          // console.log(element)
          const item = {}
          item.referencia = element.reference_number.toString()
          item.tipo = element.type
          item.productos = vm.productsInOrderExcel(element.items, true)
          item.fecha = vm.$moment(element.time).format('DD/MM/YYYY hh:mm:ss a')
          item.estado = vm.getstatus(element.items)
          item.punto = element.location_to.name
          item.total = element.total
          products.push(item)
        })
        const date = (moment().format('YYYY-MM-DD')).split('-')
        const dateFormated = date[2] + '/' + date[1] + '/' + date[0]
        const fileName = 'compras_' + dateFormated
        const xls = XLSX.utils.json_to_sheet(products)
        const wb = XLSX.utils.book_new() // make Workbook of Excel
        XLSX.utils.book_append_sheet(wb, xls, 'productos') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, fileName + '.xlsx') // name of the file is 'book.xlsx'
      },
      selectProvider () {
        const vm = this
        if (vm.selectedDate) {
          vm.fetch('purchases', false, vm.selectedDate)
        } else {
          vm.fetch('purchases', true, null)
        }
      },
      clearProvider () {
        const vm = this
        vm.provider = null
        if (vm.selectedDate) {
          vm.fetch('purchases', false, vm.selectedDate)
        } else {
          vm.fetch('purchases', true, null)
        }
      },
      getNextPages () {
        const vm = this
        if (!vm.transactions || vm.transactions.length === 0) return
        const index = vm.transactions.length
        vm.loading = true
        const bodyQuery = {
          type: 'purchases',
          from: vm.dateFrom,
          to: vm.transactions[index - 1].time,
          provider: vm.provider,
        }
        vm.$store.dispatch('transactions/loadLogPagination', bodyQuery).then(function (res) {
          vm.loading = false
        })
      },
    },
  }
</script>

<style lang='scss' scoped>
.purchases-container{
  .create-btn{
    justify-content: center;
  }
  .card-transactions{

    overflow-y: scroll !important;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .show-table-mobile{
    padding-bottom: 50px;
  }
  @media(min-width: 600px) {
    .create-btn{
      justify-content: end !important;
    }
  }
  @media(min-width: 760px) {
    .show-table-mobile{
      display: none !important;
    }
    .show-table-desktop{
      display: block !important;
    }
  }
  @media(max-width: 1100px) {
    .show-table-mobile{
      display: flex !important;
    }
    .show-table-desktop{
      display: none !important;
    }
  }
  .select {
    width: 60px;
    max-height: 60px;
    font-size: 11px;
  }
  .notification{
    display: flex;
    width: 95%;
    margin: 0 auto;
    // border-radius: 10px !important;
    box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16);
    &__container{
      @media (max-width: 1024px){
        background: transparent;
      }
    }
    &__date{
      font-size: 13px;
      color: #808184;
    }
    &__price{
      color: #35a3a9 !important;
    }
    &__description{
      color: #808184;
      font-size: 18px;
      font-weight: 300;
      line-height: 1.2;
    }
  }
  .purchases {
    &__title {
      text-align: center;
      color:#a3a4a5;
    }

    &__underline {
      position: relative;

      &:after {
        content:' ';
        position: absolute;
        top:120%;
        left:50%;
        width: 8rem;
        border:2px solid #30b5bb;
        border-radius:4px;
        transform:translateX(-50%);
      }
    }
  }
}
</style>
